import type { ReactNode } from "react";

type ImageGridProps = {
  children: ReactNode;
};

export function ImageGrid({ children }: ImageGridProps) {
  return (
    <div className="grid min-h-0 flex-1 grid-cols-2 gap-x-5 gap-y-8 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5">
      {children}
    </div>
  );
}
